<template>
  <router-link
    class="block bg-white p-2 text-nucleus-grey text-center w-full border-b-4 border-white z-10 link"
    :to="to"
  >
    <span class="block icon text-3xl" :class="'icon-' + icon"> </span>
    <span class="block leading-none capitalize">
      {{ name }}
    </span>
  </router-link>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    to: String,
    name: String,
    icon: String,
  },
})
export default class TabLink extends Vue {}
</script>

<style lang="scss" scoped>
.link {
  &.router-link-active {
    @apply text-nucleus-primaryBlue border-nucleus-primaryBlue;
  }
}
</style>
